var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandthankyoupage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 325.16 515.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#da004f;}.cls-13,.cls-14,.cls-16,.cls-2,.cls-3,.cls-5{fill:#fff;}.cls-10,.cls-11,.cls-13,.cls-14,.cls-15,.cls-16,.cls-2,.cls-3,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#000;stroke-miterlimit:10;}.cls-2{stroke-width:1.61px;}.cls-3{stroke-width:1.17px;}.cls-4{fill:#da00c6;}.cls-5{stroke-width:1.66px;}.cls-6,.cls-7{fill:#ffbace;}.cls-6{stroke-width:0.64px;}.cls-7{stroke-width:0.96px;}.cls-8{fill:#c6495d;}.cls-10,.cls-8,.cls-9{stroke-width:0.26px;}.cls-9{fill:#0f1a67;}.cls-10{fill:#7c7bd4;}.cls-11{fill:#77c12d;stroke-width:0.91px;}.cls-12{fill:#f0c62f;}.cls-13{stroke-width:0.22px;}.cls-14{stroke-width:0.17px;}.cls-15{fill:#ffcb00;stroke-width:1.04px;}.cls-16{stroke-width:1px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.81,208.13S72.75,74.18,116.82,90.6a7.84,7.84,0,0,1,6.92-6c6-.87,13.83-1.73,21.6,5.18,0,0-19-66.54-16.42-76a17.66,17.66,0,0,1,10.37-12.1s6.92-3.46,15.56,4.32c9.55,8.59,24.2,75.18,24.2,75.18S194.6,20.6,198.92,9.36a14,14,0,0,1,7.37-7.94,16.9,16.9,0,0,1,17.3,2.34,14,14,0,0,1,5.58,8.2C230.9,20.6,211,106.15,211,106.15l-19.88,102Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.35,59.14c1.77,5.54,3.43,11.1,5.09,16.67s3.27,11.14,4.85,16.73c3.19,11.17,6.23,22.37,9.24,33.59l-.74-.86,12.58,5.39,12.55,5.46,1.37.6-.92,1.13a58.14,58.14,0,0,1-7.7,7.75,35.77,35.77,0,0,1-9.28,5.8,18.06,18.06,0,0,1-5.38,1.32,12.67,12.67,0,0,1-5.49-.74c-3.51-1.37-6-4.3-7.75-7.37,2,2.9,4.71,5.53,8,6.56s6.88.31,10-1.12a36.16,36.16,0,0,0,8.6-5.91,61.07,61.07,0,0,0,7.17-7.67l.46,1.73L167.39,133l-12.61-5.31-.59-.24-.16-.62c-3-11.22-5.9-22.46-8.68-33.73-1.41-5.63-2.77-11.28-4.12-16.93S138.57,64.82,137.35,59.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8,136.83a47.87,47.87,0,0,0,2.79,6.09,43.86,43.86,0,0,0,3.52,5.66,26.79,26.79,0,0,0,4.48,4.84,14.78,14.78,0,0,0,5.66,3c4.11,1.18,8.65-.38,11.87-3a10.82,10.82,0,0,0,3.13-5.28,21.87,21.87,0,0,0,.71-6.37A48.33,48.33,0,0,0,143.61,129a71.09,71.09,0,0,0-5.12-12.15,72.64,72.64,0,0,0-7.15-11.07A48.14,48.14,0,0,0,122,96.6a24,24,0,0,0-11.61-4.87,16.09,16.09,0,0,0-6.17.57,12.93,12.93,0,0,0-1.48.51l-.37.14-.18.07,0,0-.05,0a4.1,4.1,0,0,0-.57.36,11.58,11.58,0,0,0-2.19,2.08c-2.64,3.24-4.15,7.44-5.09,11.68a112,112,0,0,0-1.82,13.14c-.75,8.88-.95,17.82-.9,26.76,0,4.46.07,8.94.25,13.4q.14,3.36.37,6.7a47.87,47.87,0,0,0,.78,6.65,86.3,86.3,0,0,1-1.83-13.3c-.37-4.47-.64-8.95-.84-13.43-.31-9-.33-17.94.19-26.92a97.92,97.92,0,0,1,1.58-13.47c.94-4.47,2.43-9,5.42-12.77a13.62,13.62,0,0,1,2.64-2.55,7.71,7.71,0,0,1,.85-.53l.13-.07.15-.06.2-.09.42-.16a13.49,13.49,0,0,1,1.69-.59,18.57,18.57,0,0,1,7.11-.69,26.48,26.48,0,0,1,12.89,5.29,50.86,50.86,0,0,1,9.77,9.67,72.43,72.43,0,0,1,7.34,11.49,74.7,74.7,0,0,1,5.11,12.63,47,47,0,0,1,2.16,13.52,23.61,23.61,0,0,1-1,6.9,12.46,12.46,0,0,1-3.8,6,14.35,14.35,0,0,1-3,1.88,17.63,17.63,0,0,1-3.28,1.21,12.87,12.87,0,0,1-7-.12,16,16,0,0,1-5.94-3.51,28.2,28.2,0,0,1-4.41-5.18A47.45,47.45,0,0,1,113.8,136.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.69,206.87H226.07a0,0,0,0,1,0,0V372.48a29.24,29.24,0,0,1-29.24,29.24h-69.9a29.24,29.24,0,0,1-29.24-29.24V206.87A0,0,0,0,1,97.69,206.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.86,208.13l-1.3-83.4S223.42,104,194.91,104s-64.82,1.73-64.82,1.73-9.5.87-8.64,16.42,32,14.69,32,14.69h27.65s-37.16,9.51-37.16,36.3,1.3,35,1.3,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.64,173.13a22.63,22.63,0,0,1,2.82-13.58,33.48,33.48,0,0,1,4-5.83,44.54,44.54,0,0,1,5-4.95,59.41,59.41,0,0,1,11.92-7.58,101.33,101.33,0,0,1,13.09-5.26l.38,1.84a186.2,186.2,0,0,1-24.08.95c-8-.28-16.14-.91-24-3.45a31,31,0,0,1-5.71-2.51,16.41,16.41,0,0,1-4.92-4.17,11.17,11.17,0,0,1-2.31-6.24,42.59,42.59,0,0,1,.14-6.18,20,20,0,0,1,1.55-6.19,12.42,12.42,0,0,1,1.81-2.82A11.69,11.69,0,0,1,129,105a16.88,16.88,0,0,1,6.13-2,44.1,44.1,0,0,1,6.14-.38c4,0,8,.16,12,.16s8,0,12,0c8,.09,16,.26,24,.81,4,.28,8,.65,12,1.26,2,.32,4,.7,5.92,1.2a30.25,30.25,0,0,1,5.74,2,16.25,16.25,0,0,1,4.84,3.7,18,18,0,0,1,3.16,5.17,26.23,26.23,0,0,1,1.59,11.82,26.45,26.45,0,0,0-2-11.65,16,16,0,0,0-7.92-8.31,43.47,43.47,0,0,0-11.5-2.66c-3.93-.49-7.9-.78-11.88-1-8-.36-15.93-.34-23.9-.24l-12,.12c-4,0-8-.08-12,0a50.29,50.29,0,0,0-5.81.4,14.3,14.3,0,0,0-5.21,1.66,8.79,8.79,0,0,0-2,1.65,9.86,9.86,0,0,0-1.4,2.21,17.67,17.67,0,0,0-1.31,5.39,41.23,41.23,0,0,0-.1,5.78,8.6,8.6,0,0,0,1.77,4.83,14,14,0,0,0,4.15,3.52,28.67,28.67,0,0,0,5.24,2.32,63.29,63.29,0,0,0,11.45,2.52c3.9.53,7.85.84,11.81,1s7.94.16,11.91.07,7.95-.25,11.89-.57l8.85-.73-8.47,2.56a99.23,99.23,0,0,0-13,4.86,63.12,63.12,0,0,0-11.85,7.09,44.12,44.12,0,0,0-5.11,4.65,32.92,32.92,0,0,0-4.12,5.54,26.84,26.84,0,0,0-2.69,6.36A19.11,19.11,0,0,0,146.64,173.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.82,90.6a6.19,6.19,0,0,1,1.31-4.12,8.94,8.94,0,0,1,3.6-2.72,17.88,17.88,0,0,1,8.67-1.09,31.87,31.87,0,0,1,8.35,1.84,15.3,15.3,0,0,1,3.83,2.07,8.29,8.29,0,0,1,1.55,1.58,3.59,3.59,0,0,1,.78,2,4,4,0,0,0-1.29-1.53,9.36,9.36,0,0,0-1.7-1,21,21,0,0,0-3.77-1.23,64,64,0,0,0-8-1.16,23,23,0,0,0-7.75.43,8.87,8.87,0,0,0-3.36,1.68A7,7,0,0,0,116.82,90.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.59,244.13s49.83-3.29,49.73,20.5l-.48-20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.59,244.13a106.43,106.43,0,0,1,14.84-.44,85.53,85.53,0,0,1,14.82,1.77c4.87,1.11,9.78,2.66,14,5.69a17.8,17.8,0,0,1,5.34,5.77,15.85,15.85,0,0,1,2,7.71l-2.55,0c-.21-7-.29-13.93-.44-20.9l1.25,1.21-12.66-.1c-4.22-.08-8.43-.19-12.57-.32C192.34,244.26,184.38,244.06,176.59,244.13Zm0,0c8.62-.07,17.07-.4,25.22-.82l12.05-.52,12-.29,1.21,0,0,1.23c.18,7,.41,13.93.52,20.9l-2.55,0a13.36,13.36,0,0,0-1.6-6.49,16.06,16.06,0,0,0-4.55-5.08,28,28,0,0,0-6.21-3.44,53.21,53.21,0,0,0-6.87-2.29,98.58,98.58,0,0,0-14.46-2.46Q184,244.13,176.59,244.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93,194.51c.7,10,1.1,20,1.39,29.93.18,5,.24,10,.36,15l.19,15,0,15c0,5,0,10-.15,15-.15,10-.42,20-1,29.95-.71-10-1.11-19.95-1.4-29.93-.18-5-.24-10-.36-15l-.18-15,0-15c0-5,0-10,.15-15C225.1,214.48,225.36,204.49,225.93,194.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.11,256c-.14-2.11-.21-4.65-.48-7.16-.44-4.16-.79-8.33-1.55-12.43-1.85-10-6.61-14.85-16.61-16.59-5.91-1-11.94-1.35-17.91-2a5.16,5.16,0,0,1-1.9-.39c2.41-.15,4.84-.17,7.23-.47,4.9-.59,9.83-1.09,14.66-2.07,7.58-1.53,12.22-6.28,14.09-13.81,1.65-6.62,2.07-13.38,2.46-20.14a10.89,10.89,0,0,1,.3-2.06c.37,4.6.67,9.2,1.14,13.79a76.9,76.9,0,0,0,1.29,7.68c1.73,8.21,6.75,13.33,15,14.79,6.2,1.09,12.52,1.54,18.79,2.25a19.25,19.25,0,0,0,2.28,0l0,.41c-.54,0-1.08.05-1.62.11-6.28.67-12.6,1.09-18.82,2.08-9.38,1.48-14.64,7.37-16,16.61C98.43,243.16,97.84,249.76,97.11,256Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70,164.87a41,41,0,1,0-15.24,9.22l25.6,25.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.63,127.58a8.56,8.56,0,0,0-4-5.5,10.59,10.59,0,0,0-14.43,4.12l-1.38,2.4-1.37-2.4A10.59,10.59,0,0,0,24,122.08a8.56,8.56,0,0,0-4,5.5C17.71,136.49,37.71,156,39.7,157.9v.17l.08-.09.09.09v-.17C41.86,156,61.86,136.49,59.63,127.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 57.72,
    y: 272.19,
    width: 100.55,
    height: 193.37,
    rx: 8.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 78.96,
    y: 430.07,
    width: 58.01,
    height: 17.4,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 57.72,
    y1: 298.44,
    x2: 157.6,
    y2: 298.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 70.72,
    cy: 287.24,
    r: 4.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 82.69,
    cy: 287.24,
    r: 4.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 94.65,
    cy: 287.24,
    r: 4.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 66.68,
    y1: 333.66,
    x2: 148.64,
    y2: 333.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 66.68,
    y1: 343.26,
    x2: 148.64,
    y2: 343.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 66.68,
    y1: 354.15,
    x2: 148.64,
    y2: 354.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 66.68,
    y1: 354.15,
    x2: 148.64,
    y2: 354.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 66.68,
    y1: 363.75,
    x2: 148.64,
    y2: 363.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 66.68,
    y1: 373.36,
    x2: 148.64,
    y2: 373.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 66.68,
    y1: 382.96,
    x2: 148.64,
    y2: 382.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 66.68,
    y1: 393.85,
    x2: 148.64,
    y2: 393.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 66.68,
    y1: 403.45,
    x2: 148.64,
    y2: 403.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 66.68,
    y1: 393.85,
    x2: 148.64,
    y2: 393.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 66.68,
    y1: 403.45,
    x2: 148.64,
    y2: 403.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 64.12,
    y: 296.52,
    width: 100.55,
    height: 193.37,
    rx: 8.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 85.37,
    y: 454.41,
    width: 58.01,
    height: 17.4,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 64.12,
    y1: 322.77,
    x2: 164.01,
    y2: 322.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 77.13,
    cy: 311.57,
    r: 4.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 89.09,
    cy: 311.57,
    r: 4.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 101.06,
    cy: 311.57,
    r: 4.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 73.08,
    y1: 357.99,
    x2: 155.04,
    y2: 357.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 73.08,
    y1: 367.59,
    x2: 155.04,
    y2: 367.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 73.08,
    y1: 378.48,
    x2: 155.04,
    y2: 378.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 73.08,
    y1: 378.48,
    x2: 155.04,
    y2: 378.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 73.08,
    y1: 388.08,
    x2: 155.04,
    y2: 388.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 73.08,
    y1: 397.69,
    x2: 155.04,
    y2: 397.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 73.08,
    y1: 407.29,
    x2: 155.04,
    y2: 407.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 73.08,
    y1: 418.18,
    x2: 155.04,
    y2: 418.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 73.08,
    y1: 427.78,
    x2: 155.04,
    y2: 427.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 73.08,
    y1: 418.18,
    x2: 155.04,
    y2: 418.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 73.08,
    y1: 427.78,
    x2: 155.04,
    y2: 427.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 71.8,
    y: 320.85,
    width: 100.55,
    height: 193.37,
    rx: 8.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 93.05,
    y: 478.74,
    width: 58.01,
    height: 17.4,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 71.8,
    y1: 347.1,
    x2: 171.69,
    y2: 347.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 84.81,
    cy: 335.9,
    r: 4.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 96.78,
    cy: 335.9,
    r: 4.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 108.74,
    cy: 335.9,
    r: 4.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 80.77,
    y1: 382.32,
    x2: 162.73,
    y2: 382.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 80.77,
    y1: 391.92,
    x2: 162.73,
    y2: 391.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 80.77,
    y1: 402.81,
    x2: 162.73,
    y2: 402.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 80.77,
    y1: 402.81,
    x2: 162.73,
    y2: 402.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 80.77,
    y1: 412.41,
    x2: 162.73,
    y2: 412.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 80.77,
    y1: 422.02,
    x2: 162.73,
    y2: 422.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 80.77,
    y1: 431.62,
    x2: 162.73,
    y2: 431.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 80.77,
    y1: 442.51,
    x2: 162.73,
    y2: 442.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 80.77,
    y1: 452.11,
    x2: 162.73,
    y2: 452.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 80.77,
    y1: 442.51,
    x2: 162.73,
    y2: 442.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 80.77,
    y1: 452.11,
    x2: 162.73,
    y2: 452.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.53,
    y: 479.42,
    width: 125.63,
    height: 16.95,
    rx: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M276.61,175.06v-1.84a14.21,14.21,0,0,0-28.42,0V175a53.86,53.86,0,0,0-39.82,52V482.68H316.05V226.94A53.85,53.85,0,0,0,276.61,175.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.1,410.09a52.62,52.62,0,0,1-52.6,52.64H247a52.43,52.43,0,0,1-38.64-16.93v36.88H316.05V226.94C316.05,210.94,302.1,410.09,302.1,410.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M232,194c-4.06,0-6.58,3.13-9.62,7.14-4.79,6.32-7.82,15.56-7.82,25.86v38.93c0,1.24.68,2.24,1.51,2.24h0c2.14,0,3.88-2.59,3.88-5.79V228.56c0-15.95,7.25-29.37,17.1-33.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 214.23,
    y: 275.2,
    width: 5.07,
    height: 21.22,
    rx: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.87,480.79a8.83,8.83,0,0,1,.12-1.37h-4a8.48,8.48,0,1,0,0,16.95H316.68a8.48,8.48,0,0,0,8.36-7.11H220.35A8.48,8.48,0,0,1,211.87,480.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M314.59,479.42H212a6.63,6.63,0,0,0,1.38,5.51,11.32,11.32,0,0,0,9.07,4.33h98.47a3.43,3.43,0,0,0,2.83-5.41l-.08-.1A11.32,11.32,0,0,0,314.59,479.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M207.34,320.8c-.08-1.31-.13-2.88-.29-4.44-.28-2.57-.49-5.16-1-7.7-1.14-6.18-4.09-9.2-10.29-10.28-3.66-.64-7.39-.84-11.1-1.23a3.06,3.06,0,0,1-1.17-.24c1.5-.09,3-.11,4.48-.29,3-.37,6.09-.68,9.08-1.28,4.7-.95,7.57-3.89,8.73-8.56a67.25,67.25,0,0,0,1.52-12.48,6.71,6.71,0,0,1,.19-1.27c.23,2.85.41,5.7.71,8.54a47.74,47.74,0,0,0,.8,4.76c1.07,5.08,4.18,8.26,9.27,9.16,3.85.68,7.76,1,11.65,1.4a13.25,13.25,0,0,0,1.41,0l0,.25-1,.07c-3.89.42-7.8.68-11.66,1.29-5.81.92-9.07,4.57-9.93,10.29C208.16,312.85,207.79,316.94,207.34,320.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandthankyoupage);
export default __webpack_public_path__ + "static/media/handthankyoupage.686216a7664aedd8dc86d818769862b6.svg";
export { ForwardRef as ReactComponent };